import * as React from 'react';
import '../css/image-lockup.sass';
import ProgrammingLockup, { ProgramDetail } from './ProgrammingLockup';

interface ImageLockupProps {
  url: string;
  alt: string;
  detail?: ProgramDetail;
  customClass?: string;
}

export default function ImageLockup(props: ImageLockupProps) {
  return (
    <div className="img-lockup">
      <img className="img" src={props.url} alt={props.alt} />
      {props.detail && (
        <ProgrammingLockup
          transparent
          details={[
            {
              pkgName: props.detail.pkgName,
              pkgImgUrl: props.detail.pkgImgUrl,
              showName: props.detail.showName
            }
          ]}
        />
      )}
    </div>
  );
}
